import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

// Aplica o tema imediatamente (usado também antes do React montar, via index.html)
function aplicar(tema) {
  const root = document.documentElement;
  if (tema === 'escuro') root.classList.add('dark');
  else root.classList.remove('dark');
}

export function ThemeProvider({ children }) {
  const [tema, setTema] = useState(() => localStorage.getItem('tema') || 'claro');

  useEffect(() => {
    aplicar(tema);
    localStorage.setItem('tema', tema);
  }, [tema]);

  return (
    <ThemeContext.Provider value={{ tema, setTema }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
